import clsx from 'clsx'
import { Portal } from 'components/utility/portal'
import React, { useEffect, useRef, useState } from 'react'

export default function ProcessorModal({ open = false, children, onClose = () => {} }) {
  const [show, setShow] = useState(open)
  const overlayRef = useRef(null)

  useEffect(() => setShow(open), [open])

  const handleClickOutsideModal = (e) => {
    if (e.target !== overlayRef.current) return
    onClose()
  }

  if (!show) return null

  return (
    <Portal>
      <div className="auto-questionnaire-processor-modal-overlay dome-full-width dome-full-height">
        <div
          ref={overlayRef}
          onClick={handleClickOutsideModal}
          className="auto-questionnaire-processor-modal-body dome-full-width dome-full-height dome-d-flex dome-align-center dome-justify-center"
        >
          {children}
        </div>
      </div>
    </Portal>
  )
}
